import { render, staticRenderFns } from "./business-consulting-add.vue?vue&type=template&id=1d4744e6&"
import script from "./business-consulting-add.vue?vue&type=script&lang=js&"
export * from "./business-consulting-add.vue?vue&type=script&lang=js&"
import style0 from "./business-consulting-add.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports